module.exports = __webpack_public_path__ + "static/media/awards_10.cfa7e64b.jpg";